
  export default {
    name: "FloatingCart",
    props: {
      data: {
        type: Array,
        required: false,
      },
      bestComb: {
        type: Object,
        required: false,
      },
      bestPrice: {
        type: Number,
        required: false,
      },
      totalPrice: {
        type: Number,
        required: false,
      },
      currency: {
        type: String,
        required: false,
      },
      searchInfo: {
        type: Object,
        required: false
      },
      visible: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    methods: {
      book() {
        if (this.bestComb) {
          this.$emit('book', this.bestComb);
          return;
        }

        this.$emit('book');
      }
    },
    computed: {
      cartUnits() {
        let totalUnits = 0;

        this.data.map((item) => {
          totalUnits += item.quantity
        });

        return totalUnits;
      },
      isCombinationAvailable() {
        return this.data || this.bestComb;
      },
      totalBestCombination() {
        return this.bestPrice + this.bestComb?.cleaning_fee
      }
    }
  };
